import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import SoftUIDashboard from "./soft-ui-dashboard";
import config from "./config";

// flag-icons — npm install --save flag-icons
import "flag-icons/css/flag-icons.min.css";

// EmailJS — npm install --save emailjs-com
// Avec emailjs-com, l'init se fait avec la clé directement (pas d'objet)
import emailjs from "emailjs-com";
emailjs.init(config.emailjsPublicKey);

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(SoftUIDashboard);
appInstance.mount("#app");